import { TinyColor } from '@ctrl/tinycolor';
export const getStyleColor = (appSettings, wixParam) => {
    return appSettings?.style?.colors?.[wixParam]?.value;
};
export const getPresetColor = (appSettings, presetName) => {
    return appSettings?.colorPresets?.find((p) => p?.reference === presetName)
        ?.value;
};
export const setColorOpacity = ({ color, alpha = 1, }) => {
    const tinyColor = new TinyColor(color).setAlpha(alpha);
    return tinyColor.toRgbString();
};
export const getSiteColor = (appSettings, { wixParam, presetFallback, colorFallback, opacity = undefined, hex = false, }) => {
    const color = getStyleColor(appSettings, wixParam) ||
        getPresetColor(appSettings, presetFallback) ||
        colorFallback;
    if (hex && opacity !== undefined) {
        throw new Error('Cannot set opacity on hex color');
    }
    if (opacity !== undefined) {
        return setColorOpacity({ color, alpha: opacity });
    }
    const tinyColor = new TinyColor(color);
    return hex ? tinyColor.toHexString() : tinyColor.toRgbString();
};
export const resolveColor = (color, colorPresets) => {
    if (!color) {
        return 'transparent';
    }
    if (!color.includes('{')) {
        return color;
    }
    const currentColor = color.replace(/[\{\}]/g, '');
    const siteColor = colorPresets?.find(({ name }) => name === currentColor);
    return siteColor?.value || 'transparent';
};
//# sourceMappingURL=colors.js.map